export const leadTypes = {
  BIG_TEX: 'bigtex-booking',
};
